if (!('structuredClone' in globalThis)) {
  import('@ungap/structured-clone').then((mod) => {
    // @ts-ignore
    globalThis.structuredClone = mod.default
  })
}
